<template>
   <div id="app">
         <div  class="labelClass" @click="clickDiv">
                <Tag
            v-for='(condition, index) in conditions' 
            :key="condition.id"
            closable
            @on-close='removeCondition(condition, index)'
            >
                {{condition.name}}
            </Tag>
        </div>
        <div v-if="showOnelLevel">
            <span v-for='(category, categoryIndex) in categories' >
                <span v-if="category.active"  class="active" @click='clickOneLevel(categoryIndex,"not-active")'>{{category.oneLevel}}</span>
                <span v-else class="not-active" @click='clickOneLevel(categoryIndex,"active")'>{{category.oneLevel}}</span>
            </span>
            <div v-if="tempCategories.length>0">
                <div v-for='(category, categoryIndex) in tempCategories' :key="category.id">
                    <span class="not-active">{{category.name}}：</span>
                    <template v-for='(child, childIndex) in category.children'>
                        <span  v-if="child.active" class="active" @click='clickChild(category, categoryIndex, child, childIndex)'>
                            {{ child.name }}
                        </span>
                        <span v-else class="not-active" @click='clickChild(category, categoryIndex, child, childIndex)'>{{ child.name }}</span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
		name: 'LabelSelect',
		components: {
		},
		props: [
           "prop"
        ],
         data() {
                return {
                 conditions: [],
                 showOnelLevel:false,
                 tempCategories:[],
                 selectedCondition:[],
                 limit:this.prop.limit,
                 categories:this.prop.categories
                }
            },
             methods: {
                  resetFields(oneTwoLevelModule){
                    let oneLevelLabel= Object.keys(oneTwoLevelModule) 
                    let allOneLevels=this.categories.map(a=>a.oneLevel)
                    for(let item of oneLevelLabel){
                        let index=allOneLevels.indexOf(item)
                        if(-1!=index){
                            let content=oneTwoLevelModule[item]
                            let secondLabel= Object.keys(content)
                            this.clickOneLevel(index,'active')
                            this.tempCategories.forEach((category, categoryIndex)=>{
                                category.children.forEach((child, childIndex)=>{
                                    for(let secondCategory of secondLabel){
                                        if(category.name===secondCategory){
                                            let childrenSplit=content[secondCategory].split(',')
                                            for(let childItem of childrenSplit){
                                                if(childItem===child.name){
                                                    this.clickChild(category, categoryIndex, child, childIndex)
                                                }
                                            }
                                        }
                                    }
                                })
                                })
                        }
                     }
                  },
                  init(){
                     this.selectedCondition=[]
                     this.conditions=[]
                     this.showOnelLevel=false
                     this.tempCategories=[]
                     for(let item of this.categories){
                         if(item.hasOwnProperty('active')&&item.active){
                             item.active=false
                         }
                         for(let child of item.children){
                             for(let item of child.children){
                                   if(item.hasOwnProperty('active')&&item.active){
                                 item.active=false
                                }
                             }
                             
                         }

                     }
                 },
                 clickDiv(){
                   this.showOnelLevel=!this.showOnelLevel
                 },
                 clickOneLevel(value,flag){
                     for(let item of this.categories){
                          item.active=false
                     }
                     if('active'===flag){
                         this.categories[value].active=true
                     }else{
                         this.categories[value].active=false
                     }
                     this.tempCategories=[]
                     let tempObj= this.categories[value].children
                     this.tempCategories=tempObj
                 },
                // 处理标签点击事件，未选中则选中，已选中则取消选中
                clickChild(category, categoryIndex, child, childIndex) {
                    let uid = `${categoryIndex}-${childIndex}`
                    child.uid = uid;
                    console.log(uid)
                    // 取消选择
                    if (child.active === true) {
                        category.count--;
                        child.active = false;
                        this.conditions.forEach((conditionChild, index) => {
                            if (conditionChild.uid === child.uid&&conditionChild.uuid === child.uuid) {
                                this.conditions.splice(index, 1);
                            }
                        });
                    // 选择
                    } else {
                        if(this.conditions.length>=this.limit){
                            this.$Message.error('您选择的标签已达上限,请合理选择标签')
                            return 
                         }
                        category.count++;
                        child.active = true;
                        this.conditions.push(child);
                    }
                },
            
                // 清除已选整个类别标签
                clearCategory(category, categoryIndex) {
                    category.count = 0;
                    
                    // 可选列表均为未选中状态
                    category.children.forEach(child => {
                        child.active = false;
                    })

                    // 清空该类已选元素
                    for (let index = this.conditions.length - 1; index >= 0; index--) {
                        const conditionChild = this.conditions[index];
                        if (conditionChild.uid.startsWith(categoryIndex)) {
                            this.conditions.splice(index, 1);
                        }
                    }
                },
                
                // 移除一个条件
                removeCondition(condition, index) {
                    let categoryIndex = condition.uid.split("-")[0];
                    // this.categories[1].child[categoryIndex].count --;
                    this.conditions.splice(index, 1)
                    condition.active = false;
                },

                // 清空所有条件
                clearCondition() {
                    for(let i = this.conditions.length-1; i >=0 ; i--){
                        this.removeCondition(this.conditions[i], i);
                    }
                }
            },
             watch: {
                // 监听条件变化，按照请求接口拼装请求参数
                conditions(val){
                    if(val.length==0){
                        this.tempCategories=[]
                        for(let item of this.categories){
                          item.active=false
                     }
                    }
                    this.selectedCondition=[]
                    let oneLevelSelect = {};
                    for(let categorie of this.categories){
                        for(let child of categorie.children){
                            let selectedCondition = {};
                            let selected_list = [];
                            for(let item of child.children){
                              if(item.active){
                                selected_list.push(item.name);
                                // categorie.active=true
                            }
                            }
                            if(selected_list.length>0){
                                if(selectedCondition.hasOwnProperty(child.name)){
                                    selectedCondition[child.name]=selectedCondition[child.name]+','+selected_list.join(",")
                                }else{
                                    selectedCondition[child.name] = selected_list.join(",")
                                }
                              
                            }
                            if(Object.keys(selectedCondition).length>0){
                                 if(oneLevelSelect.hasOwnProperty(categorie.oneLevel)){
                                    //  console.log(selectedCondition)
                                    //  console.log(oneLevelSelect)
                                     var obj=Object.assign(oneLevelSelect[categorie.oneLevel],selectedCondition)
                                     oneLevelSelect[categorie.oneLevel]=obj
                                    // oneLevelSelect[categorie.name]=oneLevelSelect[categorie.name]+','+selectedCondition.join(",")
                                }else{
                                    oneLevelSelect[categorie.oneLevel] = selectedCondition
                                }
                            }
                        }
                    }
                    this.selectedCondition[0]=oneLevelSelect
                    console.log(this.selectedCondition);
                }
            },
        }
    </script>
<style lang="scss" scoped>
       .labelClass{
            display: inline-block;
            width: 100%;
            height: 32px;
            line-height: 1.5;
            padding: 4px 7px;
            font-size: 14px;
            border: 1px solid #dcdee2;
            border-radius: 4px;
            color: #515a6e;
            background-color: #fff;
            background-image: none;
            position: relative;
            cursor: text;
            transition: border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out;
       }
       .not-active {
            display: inline-block;
            font-size: 12px;
            margin: 5px 8px;
        }
        .active {
            display: inline-block;
            font-size: 12px;
            margin: 5px 8px;
            background-color: #32b6d3;
            border-color: #32b6d3;
        }
        
        span {
            margin: 0 2px;
        }

</style>







// WEBPACK FOOTER //
// src/components/label/LabelSelect.vue